/**
 * Get person initials from a full name.
 * First + last initial, e.g. "Paul Courtois" -> "PC", "Jean Pierre Martin" -> "JM".
 * Single word falls back to its first two characters, empty name to "?".
 */
export function getInitials(name?: string | null): string {
  if (!name) return '?'

  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
